'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** OutLink */
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
var OutLink = function OutLink(props) {
  return _react2.default.createElement(
    'a',
    {
      href: props.to,
      target: '_blank',
      rel: 'noopener noreferrer',
      alt: props.to,
      style: props.style,
      className: props.className
    },
    props.children
  );
};

OutLink.propTypes = process.env.NODE_ENV !== "production" ? {
  to: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  style: _propTypes2.default.object, // eslint-disable-line
  className: _propTypes2.default.string, // eslint-disable-line
  classes: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

OutLink.defaultProps = {
  style: {}

  // ----------------------------------------------------------------------------
  // --------------------------------------------------------------------- Export
  // ----------------------------------------------------------------------------
};exports.default = OutLink;
module.exports = exports['default'];